import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'eva-checkbox',
  template: `
    <span class="eva-3-checkbox {{size}}">
      <label class="checkbox-label">
        <input class="checkbox-tag" type="checkbox" [(ngModel)]="checked" (click)="clickEvent.emit()" [disabled]="disabled">
        <i class="eva-3-icon-checkmark  checkbox-check -eva-3-mr-md"></i>
        <ng-content></ng-content>
      </label>
    </span>
  `,
  styleUrls: ['eva-checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EvaCheckboxComponent {
  @Input() size: String;
  @Input() checked: boolean;
  @Input() disabled: boolean;
  @Output() clickEvent = new EventEmitter<void>();

}
